import React from "react";
import NameHeader from "../shared/NameHeader";
import Summary from "../shared/Summary";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import ScannerViewData, {
  defaultScannerViewData,
} from "../../models/scanner/ScannerViewData";
import scannerByIdStore from "../../flux/stores/scanner/ByIdStore";

import History from "../../utilities/History";
import renderBreadcrumb from "../../utilities/Breadcrumb";

interface ILandingState {
  scannerData: ScannerViewData;
}

export default class Landing extends React.Component<{}, ILandingState> {
  private _mount: boolean = false;

  constructor(props: {}) {
    super(props);
    this._mount = true;
    this.state = {
      scannerData: defaultScannerViewData,
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    scannerByIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this.setState({ scannerData: state.data }, () => {
          if (this.state.scannerData.isDelimited) {
            const arr = this.state.scannerData.scannerContent.split(
              this.state.scannerData.delimiter || ","
            );
            const mappings: any[] = [];
            this.state.scannerData?.mappings?.map((d, i) => {
              mappings.push({ ...d, dataValue: arr[i] });
            });
            this.setState({
              scannerData: {
                ...this.state.scannerData,
                mappings,
              },
            });
          } else {
            const mappings: any[] = [];
            this.state.scannerData?.mappings?.map((d, i) => {
              const dataValue = this.state.scannerData.scannerContent.substring(
                d.startIndex - 1,
                d.endIndex
              );
              mappings.push({ ...d, dataValue });
            });
            this.setState({
              scannerData: {
                ...this.state.scannerData,
                mappings,
              },
            });
          }
        });
      }
    });
  }

  public breadcrumpClick = (link: string): void => {
    if (link) History.push(link);
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-layout">
            {renderBreadcrumb(
              [
                { text: t("Home"), link: "/samplenew", bolder: false },
                { text: t(CONSTANTS.MENU_CONFIG), link: null, bolder: false },
                { text: t(CONSTANTS.MENU_SCANNER), link: null, bolder: true }
              ], "pl-3 pb-3")
            }
            <NameHeader authKey={CONSTANTS.AUTHKEY_SCANNER} data={this.state.scannerData?.name} />
            <div className="summary-layout">
              <Summary>
                <div className="page-scroll">
                  <div className="row mt-3">
                    <div className="col-md-3">
                      <span className="summary-label">
                        {" "}
                        {t(CONSTANTS.LABEL_FORMAT_TYPE)}:
                      </span>
                      <span className="summary-value ml-2">
                        {t(this.state.scannerData?.delimiterValue)}
                      </span>
                    </div>

                    <div className="col-md-2">
                      <span className="summary-label">
                        {t(CONSTANTS.ENABLE)}:
                      </span>
                      <span className="summary-value ml-2">
                        {t(this.state.scannerData?.enableValue)}
                      </span>
                    </div>

                    {this.state.scannerData.isDelimited && (
                      <div className="col-md-2">
                        <span className="summary-label">
                          {t(CONSTANTS.DELIMITER)}:
                        </span>
                        <span className="summary-value ml-2">
                          {t(this.state.scannerData?.delimiter)}
                        </span>
                      </div>
                    )}

                    <div className="col-md">
                      <span className="summary-label">
                        {t(CONSTANTS.LABEL_PREVIEW)}:
                      </span>
                      <span className="summary-value ml-2">
                        {this.state.scannerData?.scannerContent}
                      </span>
                    </div>
                  </div>
                </div>
              </Summary>
            </div>
            <div className="summary-layout">
              <div className="summary pb-2">
                <div className="summary-text">
                  {t(CONSTANTS.LABEL_MAPPINGS)}
                </div>
                <div className="header-underline" />
                <table className="abb-scanner-table px-3 w-100">
                  <thead>
                    <tr>
                      <th>{t(CONSTANTS.LABEL_KEY_FIELD)}</th>
                      {!this.state.scannerData.isDelimited && (
                        <React.Fragment>
                          <th>{t(CONSTANTS.LABEL_START_NUMBER)}</th>
                          <th>{t(CONSTANTS.LABEL_END_NUMBER)}</th>
                        </React.Fragment>
                      )}
                      <th>{t(CONSTANTS.LABEL_VALUE)}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.scannerData.mappings.map((d, i) => {
                      return (
                        <React.Fragment key={i}>
                          <tr>
                            <td className="normal-row">{d.sampleFieldKey}</td>
                            {!this.state.scannerData.isDelimited && (
                              <React.Fragment>
                                <td className="normal-row">{d.startIndex}</td>
                                <td className="normal-row">{d.endIndex}</td>
                              </React.Fragment>
                            )}
                            <td className="normal-row">{d?.dataValue}</td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
